import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
  name: "searchViewing",
})
export class SearchViewingPipe implements PipeTransform {
  transform(pipeData, { viewing, currentFestival }): any {
    if (currentFestival === "teen-screen") {
      return pipeData.filter((eachItem) => {
        if (eachItem["fields"]["viewingOptions"]) {
          return eachItem["fields"]["viewingOptions"].includes(viewing)
        } else if (viewing !== "Virtual") {
          return eachItem
        }
      })
    } else {
      return pipeData
    }
  }
}
